import * as React from "react";
import type { SVGProps } from "react";
const SvgPmOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M7.041.685a.67.67 0 0 1-.044.724 4 4 0 0 0 5.594 5.594.667.667 0 0 1 1.06.598A6.666 6.666 0 1 1 6.4.349a.67.67 0 0 1 .642.336M5.198 1.972a5.333 5.333 0 1 0 6.83 6.83 5.333 5.333 0 0 1-6.83-6.83"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPmOutlined;
